var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading78_container"},[_c('div',{staticClass:"loader-1"},[_c('div',{staticClass:"loader-2"}),_c('div',{staticClass:"loader-3"}),_c('div',{staticClass:"loader-4"})])])
}]

export { render, staticRenderFns }